import React, { Component } from "react";
import "react-datepicker/dist/react-datepicker.css";
import UI from "../../shared/Components/UI/js";
// import TouchableOpacity, { mem, StyleSheet, Text, View } from "../../shared/custom-react-native";
import MainLayout from "../_components/MainLayout";
import EcommerceUserGroupSubscriptionListTable from "./EcommerceUserGroupSubscriptionListTable";
// import "./css.css";


export default class EcommerceUserGroupSubscriptionList extends Component {
  constructor(props) {
    super(props);
    UI.initiateView(this, {
      //Initial State Here
      active_tab: "Subscription List",
      is_drawer_open: false,
      selected: null,
      context:"merchant"
    });
  }
  
  render() {
    const _this = this;

    return (
      <MainLayout context={this.state.context} additional={"subscriptions"} _this={_this}>
        <EcommerceUserGroupSubscriptionListTable _this={_this}/>
      </MainLayout>
    );
  }
}
